import { RequestStatus, Failure, Success, NotStarted, Requesting, } from "types/requests";
export function combineRemoteData(first, second) {
    switch (first.type) {
        case RequestStatus.FAILURE: {
            return Failure(first.reason);
        }
        case RequestStatus.SUCCESS: {
            switch (second.type) {
                case RequestStatus.SUCCESS: {
                    return Success({
                        first: first.result,
                        second: second.result,
                    });
                }
                case RequestStatus.FAILURE: {
                    return Failure(second.reason);
                }
                default: {
                    return {
                        type: second.type,
                    };
                }
            }
        }
        case RequestStatus.NOT_STARTED: {
            switch (second.type) {
                case RequestStatus.FAILURE: {
                    return Failure(second.reason);
                }
                default: {
                    return NotStarted();
                }
            }
        }
        case RequestStatus.REQUESTING: {
            switch (second.type) {
                case RequestStatus.FAILURE: {
                    return Failure(second.reason);
                }
                case RequestStatus.NOT_STARTED: {
                    return NotStarted();
                }
                default: {
                    return Requesting();
                }
            }
        }
        default: {
            return NotStarted();
        }
    }
}
export function getCheckTotal(checkInfo) {
    var netTotal = checkInfo.netTotal, mandatoryTipAmount = checkInfo.mandatoryTipAmount, tax = checkInfo.tax;
    return netTotal.add(mandatoryTipAmount).add(tax);
}
